// Libraries
import { Center, Spinner as ChakraSpinner } from '@chakra-ui/react';
// Types
import { SpinnerProps } from './Spinner.types';

/**
 * A spinning loading indicator.
 * @component
 * @param {SpinnerProps} props - The props for the Spinner component.
 * @param {string} props.size - The size of the spinner. Valid values are 'xs', 'sm', 'md', 'lg', 'xl', or a custom size.
 * @param {string | number} props.minH - The minimum height of the spinner container. It can be a CSS value or a number representing pixels.
 * @returns {ReactElement} The Spinner component.
 */
export const Spinner = ({ size, minH, color = 'gray.300' }: SpinnerProps) => {
  return (
    <Center minH={minH}>
      <ChakraSpinner thickness='6px' speed='0.65s' emptyColor='gray.200' color={color} size={size} />
    </Center>
  );
};
